import React, { Component } from "react";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import $, { error } from "jquery";
import draftToHtml from "draftjs-to-html";
import { ToastContainer, toast } from "react-toastify";
import Loader from "react-loader-spinner";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import Select from "react-select";
import GetDomains from "../GetDomains";
// import { Document, Page } from 'react-pdf';

export default class KnowledgeDocument extends Component {
  constructor() {
    super();

    this.dialogClose = () => {
      this.setState({
        hideDeletePopup: false,
      });
    };

    this.settings = { effect: "Zoom", duration: 600, delay: 0 };

    //for delete dialog component ok click
    this.buttons = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          this.deleteDocumentApi();
          this.setState({ disabled: false });
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideDeletePopup: false,
            disabled: false,
          });
        },
      },
    ];

    //for delete success
    this.deleteSuccessbuttons = [
      {
        buttonModel: {
          content: "Ok",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          this.dialogInstance.hide();
          this.fetchDataApi();
          this.setState({ disabled: false });
        },
      },
    ];

    this.state = {
      addTextArea: false,
      editorState: EditorState.createEmpty(),
      documentList: [],
      planDocCharacterCount: 0,
      showLoader: false,
      editedId: -1,
      languageList: [],
      language: "",
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      showEditAction: false,
      autoTranslateChecked: false,
      hoverId: -1,
      documentCount: 0,
      isDocLimitExceeded: false,
      showFileUploadOverlay: false,
      selectedDomainValue: "",
      domainId: "",
      languageId: "",
      showFileModal: false,
      selectedFileId: null,
      selectedFileType: null,
    };
    this.domains = [];
    this.availableLangages = [];
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    this.editDocument = this.editDocument.bind(this);
    this.editImageSrc = "./assets/images/edit2.png";
  }

  componentDidMount() {
    setTimeout(() => {
      this.fetchDomainsApi();
      this.fetchLanguageApi();
      this.fetchKnowledgeDocumentListApi();
    }, 300);
    var thisComponent = this;
    document.addEventListener("projectChanged", function (event) {
      thisComponent.state.languageList = [];
      thisComponent.state.documentList = [];
      thisComponent.domains = [];
      thisComponent.availableLangages = [];
      thisComponent.state.addTextArea = false;
      thisComponent.state.language = "";
      thisComponent.state.selectedFileId = null;
      thisComponent.state.selectedFileType = null;
      thisComponent.projectId = event.projectId;
      thisComponent.fetchLanguageApi(event.projectId);
      thisComponent.fetchDomainsApi(event.projectId);
      thisComponent.fetchKnowledgeDocumentListApi(event.projectId);
    });
  }

  fetchLanguageApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    var thisController = this;
    thisController.state.successResp = false;
    var isLanguageInCurrentProject = false;
    $.ajax({
      url: "/api/project-languages-selected",
      async: false,
      method: "GET",
      data: {
        projectId: projectId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      success: function (res) {
        if (res.success === true) {
          var loadlanguage = res.result;
          thisController.state.successResp = true;
          for (var i = 0; i < loadlanguage.length; i++) {
            if (
              localStorage.getItem("languageId") !== undefined &&
              loadlanguage[i]["code"] === localStorage.getItem("languageId")
            ) {
              isLanguageInCurrentProject = true;
            }
            thisController.availableLangages.push({
              value: loadlanguage[i]["code"],
              label: loadlanguage[i]["name"],
            });
          }

          if (thisController.props.location.state !== undefined) {
            if (isLanguageInCurrentProject) {
              thisController.state.selectedLanguageValue =
                localStorage.getItem("name");
              thisController.state.languageId =
                localStorage.getItem("languageId");
            } else {
              thisController.state.selectedLanguageValue =
                thisController.availableLangages[0].label;
              thisController.state.languageId = loadlanguage[0]["code"];
            }
          } else {
            thisController.state.selectedLanguageValue =
              thisController.availableLangages[0].label;
            thisController.state.languageId = loadlanguage[0]["code"];
          }
          thisController.setState(thisController.state);
        } else {
          thisController.notifyFailedToLoadLanguages();
        }
      },
    });
  };

  notifyFailedToLoadLanguages() {
    toast.dismiss();
    toast(
      <b style={{ color: "red" }}>
        Oops! Error occurred loading languages.Please try again
      </b>,
      {
        position: "top-center",
        color: "red",
      }
    );
  }

  fetchKnowledgeDocumentListApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    var thisComponent = this;
    // thisComponent.state.showLoader = true;
    $.ajax({
      url: "/api/knowledge-document",
      async: false,
      method: "GET",
      data: {
        projectId: projectId,
        language: thisComponent.state.languageId,
        domainId: thisComponent.state.domainId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        thisComponent.state.showLoader = false;
        if (res.success === true) {
          thisComponent.state.documentList = res.result.documentList;
          if (res.result.documentList.length > res.result.documentCount) {
            thisComponent.state.isDocLimitExceeded = true;
          } else {
            thisComponent.state.isDocLimitExceeded = false;
          }
          thisComponent.state.showFileUploadOverlay = false;
          thisComponent.setState(thisComponent.state);
        }
        thisComponent.state.showFileUploadOverlay = false;
        thisComponent.setState(thisComponent.state);
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      },
    });
  };

  notifyFailedToLoad(response) {
    if (/null/i.test(response)) {
      this.notifyError();
    } else {
      toast.dismiss();
      toast(<b style={{ color: "red" }}>{response}</b>, {
        position: "top-center",
        color: "red",
      });
    }
  }

  notifyError = () => {
    toast.dismiss();
    toast(
      <b style={{ color: "red" }}>Oops! Error occurred. Please try again</b>,
      {
        position: "top-center",
        color: "red",
      }
    );
  };

  onEditorStateChange = (editorState) => {
    const contentState = editorState.getCurrentContent();
    const oldContent = this.state.editorState.getCurrentContent();
    if (contentState.getPlainText().length > 1000) {
      const editorState = EditorState.moveFocusToEnd(
        EditorState.push(
          this.state.editorState,
          ContentState.createFromText(oldContent.getPlainText())
        )
      );
      this.state.editorState = editorState;
    } else {
      this.state.editorState = editorState;
    }
    this.setState(this.state);
  };

  notifyWarning = (message) => {
    toast.dismiss();
    toast(
      <b>
        <img
          src="./assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;{message}
      </b>,
      {
        position: "top-center",
      }
    );
  };

  notifySuccess(message) {
    toast.dismiss();
    toast(
      <b>
        <img
          src="./assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;{message}
      </b>,
      {
        position: "top-center",
      }
    );
  }

  fetchDomainsApi = () => {
    var domainList = GetDomains();
    var isDomainIdInCurrentProject = false;
    for (var i = 0; i < domainList.length; i++) {
      if (
        localStorage.getItem("docDomainId") !== undefined &&
        domainList[i]["domainId"] === localStorage.getItem("docDomainId")
      ) {
        isDomainIdInCurrentProject = true;
      }
      this.domains.push({
        value: domainList[i]["domainId"],
        label: domainList[i]["domain"],
      });
    }

    if (this.props.location.state !== undefined) {
      if (isDomainIdInCurrentProject) {
        this.state.selectedDomainValue = localStorage.getItem("docDomainName");
        this.state.domainId = localStorage.getItem("docDomainId");
      } else {
        this.state.selectedDomainValue = this.domains[0].label;
        this.state.domainId = domainList[0]["domainId"];
      }
    } else {
      this.state.selectedDomainValue = this.domains[0].label;
      this.state.domainId = domainList[0]["domainId"];
    }
  };

  editDocument = (id, autoTranslate) => {
    this.state.editedId = id;
    this.state.addTextArea = true;
    this.state.autoTranslateChecked = autoTranslate;
    var docTextArea = document.getElementById("docTextArea" + id).innerHTML;
    this.state.editorState = EditorState.createWithContent(
      ContentState.createFromBlockArray(convertFromHTML(docTextArea))
    );
    this.setState(this.state);
  };

  refreshData = () => {
    var thisController = this;
    thisController.state.documentList = [];
    thisController.state.addTextArea = false;
    thisController.fetchKnowledgeDocumentListApi();
  };

  deleteDocumentApi = () => {
    let thisController = this;

    if (thisController.state.selectedFileId == null) {
      thisController.setState({ hideDeletePopup: false });
      thisController.setState({ hideDeleteSuccessPopup: true });
    }

    $.ajax({
      url: "/api/knowledge-document/" + thisController.state.selectedFileId,
      async: false,
      method: "DELETE",
      headers: {
        Authorization: "Bearer" + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          thisController.state.addTextArea = false;
          thisController.state.showFileModal = false;
          thisController.state.selectedFileId = null;
          thisController.state.selectedFileType = null;
          thisController.setState({ hideDeletePopup: false });
          thisController.fetchKnowledgeDocumentListApi();
          thisController.notifySuccess("Document deleted successfully");
        } else {
          thisController.notifyFailedToLoad(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      },
    });
  };

  handleMouseEnterDoc = (id) => {
    this.state.hoverId = id;
    this.setState(this.state);
  };

  handleMouseLeaveDoc = () => {
    this.state.hoverId = -1;
    this.setState(this.state);
  };

  addDocument = () => {
    if (this.state.isDocLimitExceeded) {
      this.notifyWarning("Document limit exceeded for the selected plan");
    } else {
      this.setState({
        showFileUploadOverlay: true,
      });
    }
  };

  hideFileUploadOverlay = () => {
    this.setState({
      showFileUploadOverlay: false,
    });
  };

  handleLangChange = (e) => {
    this.state.selectedLanguageValue = e.label;
    this.state.languageId = e.value;
    localStorage.setItem("name", e.label);
    localStorage.setItem("languageId", e.value);
    this.setState(this.state);
    this.fetchKnowledgeDocumentListApi();
  };

  handleDomainChange = (e) => {
    this.state.selectedDomainValue = e.label;
    this.state.domainId = e.value;
    localStorage.setItem("docDomainName", e.label);
    localStorage.setItem("docDomainId", e.value);
    this.setState(this.state);
    this.fetchKnowledgeDocumentListApi();
  };

  onFileUpload = (response) => {
    if (response) {
      this.notifySuccess("Document uploaded successfully");
    } else {
      this.notifyFailedToLoad("Document failed to upload");
    }
    this.fetchKnowledgeDocumentListApi();
  };

  handleFileClick = (file) => {
    console.log("File clicked:", file.fileName);
    this.state.showFileModal = true;
    this.state.selectedFileId = file.id;
    this.state.selectedFileType = file.documentType;
    this.setState(this.state);
  };

  closeFileOverlay = () => {
    this.state.showFileModal = false;
    this.state.selectedFileId = null;
    this.state.selectedFileType = null;
    this.setState(this.state);
  };

  downloadDocument = () => {
    const downloadUrl =
      "/api/knowledge-document/download/" + this.state.selectedFileId;
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  getExtensionFromContentType = (contentType) => {
    switch (contentType) {
      case "application/pdf":
        return "pdf";
      case "application/msword":
        return "doc";
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        return "docx";
      case "text/plain":
        return "txt";
      case "application/json":
        return "json";
      default:
        return "dat"; // Use .dat for unknown file types
    }
  };

  notifyFailToCreate() {
    toast(
      <b style={{ color: "red" }}>Oops! Error occurred. \n Please try again</b>,
      {
        position: "top-center",
        color: "red",
      }
    );
  }

  render() {
    const { editorState } = this.state;
    const selectedDomainOption = this.state.selectedDomainValue;
    const selectedLanguageOption = this.state.selectedLanguageValue;
    return (
      <div>
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={this.state.showLoader}
          height={300}
          width={50}
          style={{ textAlign: "center" }}
        />

        <div style={{ display: !this.state.showLoader ? "block" : "none" }}>
          <link rel="stylesheet" href="assets/css/toggleButton.css" />
          <link href="./assets/css/style.css" rel="stylesheet" />
          {/* for toaster */}
          <link rel="stylesheet" href="./assets/css/ReactToastify.css" />

          {/* for dialog component */}
          <link href="./assets/css/ej2-base.css" rel="stylesheet" />
          <link href="./assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="./assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="./assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="./assets/css/screenResolution.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />

          <ToastContainer className="Toast-at-center" />

          <div className="content-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-5">
                  <h1 className="m-0 page-title">Document Reading</h1>
                  <h6 className="taglineTxt">
                    Make agents learn from documents
                  </h6>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="card-body p-0 mb-25">
                    <div className="tab-content col-12 p-0">
                      <div className="tab-pane active show" id="tab_1">
                        <div className="card card-primary mt-3">
                          <div
                            className="card-body raise-form"
                            style={{ minHeight: "450px" }}
                          >
                            <div className="row">
                              <div className="col-sm-3">
                                <h6
                                  className="nav-item"
                                  style={{
                                    color: "#282a65",
                                    marginTop: "10px",
                                  }}
                                >
                                  Provide passages for Agent to learn
                                </h6>
                              </div>
                              <div
                                className="row"
                                style={{
                                  flex: "auto",
                                  marginBottom: "15px",
                                  justifyContent: "center",
                                  flexWrap: "nowrap",
                                }}
                              >
                                <div
                                  className="col-sm-3"
                                  style={{ flex: "auto", maxWidth: "none" }}
                                >
                                  <Select
                                    value={this.availableLangages.filter(
                                      (option) =>
                                        option.label === selectedLanguageOption
                                    )}
                                    alue={this.availableLangages.filter(
                                      (option) =>
                                        option.label === selectedLanguageOption
                                    )}
                                    onChange={this.handleLangChange}
                                    options={this.availableLangages}
                                  />
                                </div>

                                <div
                                  className="col-sm-4"
                                  style={{ flex: "auto", maxWidth: "none" }}
                                >
                                  <Select
                                    value={this.domains.filter(
                                      (option) =>
                                        option.label === selectedDomainOption
                                    )}
                                    onChange={this.handleDomainChange}
                                    options={this.domains}
                                  />
                                </div>
                              </div>

                              <div
                                className="d-flex flex-row-reverse pt-2 col-sm-2"
                                align="right"
                              >
                                <button
                                  title="Refresh"
                                  onClick={this.refreshData}
                                  type="button"
                                  className="btn action-button"
                                >
                                  <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>

                                <button
                                  className="btn action-button "
                                  title="Add"
                                  id="addMsg"
                                  style={{ marginRight: "-2px" }}
                                  onClick={this.addDocument}
                                >
                                  <img src="assets/images/add_white_24dp.png" />
                                </button>
                              </div>
                            </div>

                            <div className="row">
                              <div
                                className="col-12"
                                style={{ display: "flex", flexWrap: "wrap" }}
                              >
                                {this.state.documentList.map((file, index) => (
                                  <div
                                    style={{
                                      display: "inline-grid",
                                      marginRight: "2rem",
                                    }}
                                    key={index}
                                    onClick={() => this.handleFileClick(file)}
                                  >
                                    <img
                                      className="display-file-icon"
                                      src={getFileIcon(file.fileName)}
                                      alt={file.fileName}
                                    />
                                    <label className="file-name-label">
                                      {file.fileName}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {this.state.showFileUploadOverlay && (
                <FileUploadOverlay
                  onFileUpload={this.onFileUpload}
                  onClose={this.hideFileUploadOverlay}
                  languages={this.availableLangages}
                  selectedLanguage={this.state.selectedLanguageValue}
                  domains={this.domains}
                  selectedDomain={this.state.selectedDomainValue}
                  domainId={this.state.domainId}
                  languageId={this.state.languageId}
                />
              )}
            </div>
          </div>

          {/*Overlay to show file content*/}
          <div className="wrapper">
            <div
              className="modal"
              style={{ display: this.state.showFileModal ? "block" : "none" }}
            >
              <div className="modal-dialog" style={{ marginTop: "1%" }}>
                <div
                  className="modal-content"
                  style={{ height: "46rem", width: "46rem" }}
                >
                  <div
                    className="modal-header noBorder"
                    style={{ height: "39px" }}
                  >
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      id="close_id"
                      onClick={this.closeFileOverlay}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                      >
                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        <path d="M0 0h24v24H0z" fill="none" />
                      </svg>
                    </button>
                  </div>
                  <div className="modal-body">
                    {this.state.showFileModal &&
                      (this.state.selectedFileType == "PDF" ? (
                        <embed
                          src={
                            "/api/knowledge-document/view/" +
                            this.state.selectedFileId
                          }
                          className="kd-file-overlay"
                          type="application/pdf"
                        />
                      ) : (
                        <iframe
                          src={
                            "/api/knowledge-document/view/" +
                            this.state.selectedFileId
                          }
                          className="kd-file-overlay"
                          title="Knowledge document"
                        />
                      ))}
                  </div>
                  <div className="modal-footer noBorder">
                    <button
                      type="button"
                      className="btn btn-primary navyblue-btn mx-auto"
                      data-dismiss="modal"
                      onClick={this.downloadDocument}
                    >
                      Download
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary navyblue-btn mx-auto"
                      data-dismiss="modal"
                      style={{ background: "#7b1010" }}
                      onClick={() => this.setState({ hideDeletePopup: true })}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*Dialog Component For Deletion Confirmation*/}
          <DialogComponent
            width="400px"
            animationSettings={this.settings}
            header="Delete Confirmation"
            showCloseIcon={true}
            buttons={this.buttons}
            ref={(dialog) => (this.dialogInstance = dialog)}
            visible={this.state.hideDeletePopup}
            close={this.dialogClose}
          >
            <img
              src="assets/images/warn.svg"
              style={{ paddingRight: "0px", height: "20px", width: "20px" }}
              content=""
            />
            &nbsp;Do you want to delete this document? Note: Press 'Yes' to
            delete or press 'No' to decline.
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </DialogComponent>
        </div>
      </div>
    );
  }
}

class FileUploadOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: null,
      selectedFileType: null,
      error: null,
      selectedLanguageValue: props.selectedLanguage,
      selectedDomainValue: props.selectedDomain,
      domainId: props.domainId,
      languageId: props.languageId,
    };
  }

  handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) {
      this.setState({
        error: "Invalid file type.",
        selectedFileType: null,
        selectedFile: null,
      });
      return;
    }
    const fileType = selectedFile.name.split(".").pop();
    const validFiles = ["pdf", "docx", "txt", "json", "doc"];
    if (validFiles.indexOf(fileType) === -1) {
      this.setState({
        error: "Invalid file type.",
        selectedFileType: null,
        selectedFile: null,
      });
      return;
    }
    this.setState({ selectedFile, selectedFileType: fileType, error: null });
  };

  handleLangChangeInOverlay = (e) => {
    this.state.selectedLanguageValue = e.label;
    this.state.languageId = e.value;
    localStorage.setItem("name", e.label);
    localStorage.setItem("languageId", e.value);
    this.setState(this.state);
  };

  handleDomainChangeInOverlay = (e) => {
    this.state.selectedDomainValue = e.label;
    this.state.domainId = e.value;
    localStorage.setItem("docDomainName", e.label);
    localStorage.setItem("docDomainId", e.value);
    this.setState(this.state);
    // this.fetchKnowledgeDocumentListApi();
  };

  uploadDocument = () => {
    var thisController = this;

    const domainId = thisController.state.domainId;
    const projectId = localStorage.getItem("currentProjectId");

    var formData = new FormData();
    formData.append("domainId", domainId);
    formData.append("projectId", projectId);
    formData.append("language", thisController.state.languageId);
    formData.append("fileName", thisController.state.selectedFile.name);
    formData.append(
      "documentType",
      thisController.state.selectedFileType.toUpperCase()
    );
    formData.append("document", thisController.state.selectedFile);

    $.ajax({
      url: "/api/knowledge-document",
      async: false,
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: formData,
      processData: false,
      contentType: false,
      success: function (res) {
        if (res.success === true) {
          thisController.props.onFileUpload(true);
        } else {
          thisController.props.onFileUpload(false);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      },
    });
  };

  render() {
    const {
      onClose,
      onFileUpload,
      languages,
      domains,
      selectedLanguage,
      selectedDomain,
    } = this.props;
    const { selectedFile, selectedFileType, error } = this.state;
    const styleObj = {
      selectedBorder: "4px solid rgb(45 41 171)",
      normalBorder: "1px solid #ccc",
      normalOpacity: "35%",
      selectedOpacity: "100%",
    };
    return (
      <div className="kd-overlay-container">
        <div className="kd-overlay-box">
          <img
            className="kd-cancel-icon"
            src="./assets/images/cancel_icon.png"
            alt="Close"
            onClick={onClose}
          />

          <div
            style={{
              marginLeft: "2rem",
              lineHeight: "1.2",
              marginBottom: "1rem",
            }}
          >
            <h1>Upload Your File</h1>
            <p>File should be .pdf, .docx, .txt, .json</p>
          </div>

          <div
            className="row"
            style={{
              marginBottom: "15px",
              justifyContent: "center",
              flexWrap: "nowrap",
            }}
          >
            <div
              className="col-sm-3"
              style={{ flex: "auto", maxWidth: "none" }}
            >
              <Select
                value={languages.filter(
                  (option) => option.label === this.state.selectedLanguageValue
                )}
                onChange={this.handleLangChangeInOverlay}
                options={languages}
              />
            </div>

            <div
              className="col-sm-4"
              style={{ flex: "auto", maxWidth: "none" }}
            >
              <Select
                value={domains.filter(
                  (option) => option.label === this.state.selectedDomainValue
                )}
                onChange={this.handleDomainChangeInOverlay}
                options={domains}
              />
            </div>
          </div>

          <div className="kd-file-icons">
            <img
              style={{
                border:
                  selectedFileType === "pdf"
                    ? styleObj.selectedBorder
                    : styleObj.normalBorder,
                opacity:
                  selectedFileType === "pdf"
                    ? styleObj.selectedOpacity
                    : styleObj.normalOpacity,
              }}
              className="kd-file-icon"
              src="./assets/images/pdf_icon.png"
              alt="PDF"
            />
            <img
              style={{
                border:
                  selectedFileType === "docx"
                    ? styleObj.selectedBorder
                    : styleObj.normalBorder,
                opacity:
                  selectedFileType === "docx"
                    ? styleObj.selectedOpacity
                    : styleObj.normalOpacity,
              }}
              className="kd-file-icon"
              src="./assets/images/docx_icon.png"
              alt="DOC"
            />
            <img
              style={{
                border:
                  selectedFileType === "txt"
                    ? styleObj.selectedBorder
                    : styleObj.normalBorder,
                opacity:
                  selectedFileType === "txt"
                    ? styleObj.selectedOpacity
                    : styleObj.normalOpacity,
              }}
              className="kd-file-icon"
              src="./assets/images/txt_icon.png"
              alt="TXT"
            />
            <img
              style={{
                border:
                  selectedFileType === "json"
                    ? styleObj.selectedBorder
                    : styleObj.normalBorder,
                opacity:
                  selectedFileType === "json"
                    ? styleObj.selectedOpacity
                    : styleObj.normalOpacity,
              }}
              className="kd-file-icon"
              src="./assets/images/json_icon.png"
              alt="JSON"
            />
          </div>

          <div
            className="kd-upload-box"
            onDragEnd={() => console.log("drag ended")}
          >
            {selectedFile && (
              <div className="kd-selected-file">
                <img
                  src={getFileIcon(selectedFile.name)}
                  style={{
                    width: "4rem",
                    height: "auto",
                    marginBottom: "1rem",
                  }}
                  alt="Selected File"
                />
              </div>
            )}

            {error && <h2 className="file-error">{error}</h2>}
            <form id="fileForm">
              <div class="kd-input_container">
                <input
                  type="file"
                  id="fileUpload"
                  accept=".pdf, .docx, .txt, .json"
                  onChange={this.handleFileChange}
                />
              </div>
            </form>
          </div>

          {selectedFile && (
            <button
              className="kd-save-button"
              id=""
              onClick={this.uploadDocument}
            >
              Upload document
            </button>
          )}
        </div>
      </div>
    );
  }
}

function getFileIcon(filename) {
  const fileType = filename.split(".").pop();
  switch (fileType) {
    case "pdf":
      return "./assets/images/pdf_icon.png";

    case "docx":
      return "./assets/images/docx_icon.png";

    case "txt":
      return "./assets/images/txt_icon.png";

    case "json":
      return "./assets/images/json_icon.png";

    default:
      return null;
  }
}



// WEBPACK FOOTER //
// ./src/projectmgmt/faq/KnowledgeDocument.js